import { Policies } from './Policies';
export default Policies;



// WEBPACK FOOTER //
// ./src/components/atomic/molecules/Policies/index.js